import { DateTime } from 'luxon'
import { formatDateTime } from '../../utils/dateFormat'
import { REPORTS_CALENDAR_TZ } from './constants'

export const REPORTS_CALENDAR_TIMEZONE =
  process.env.REACT_APP_REPORTS_CALENDAR_TIMEZONE?.trim() || REPORTS_CALENDAR_TZ

export const getDefaultRange = () => {
  const today = DateTime.now().setZone(REPORTS_CALENDAR_TIMEZONE).startOf('day')
  const start = today.minus({ days: 29 })
  return {
    startDate: start.toFormat('yyyy-MM-dd'),
    endDate: today.toFormat('yyyy-MM-dd'),
  }
}

export const fmtDate = (value) => formatDateTime(value, 'N/A')
export const fmtAmount = (value) => `৳${Number(value || 0).toFixed(2)}`

/**
 * Parse order timestamps.
 * Legacy date-only values are business-calendar days; API timestamptz values
 * are instants and are rendered in the active browser timezone.
 */
export const parseOrderTimestamp = (value) => {
  if (value == null || value === '') return null
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value
  }

  const str = String(value).trim()
  if (!str) return null

  if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
    const dt = DateTime.fromISO(str, { zone: REPORTS_CALENDAR_TIMEZONE }).startOf('day')
    return dt.isValid ? dt.toJSDate() : null
  }

  const date = new Date(str)
  return Number.isNaN(date.getTime()) ? null : date
}

/** Prefer last-modified instant for activity lists; fall back to creation time. */
export const getSaleOrderListTimestamp = (item) =>
  item?.dateModified ??
  item?.date_modified ??
  item?.saleAt ??
  item?.orderDate ??
  item?.order_date ??
  null

export const fmtSaleDateTime = (value) => {
  const date = parseOrderTimestamp(value)
  if (!date) return value ? String(value) : 'N/A'
  return formatDateTime(date, value ? String(value) : 'N/A')
}

export const parseSalesSummary = (res) => ({
  totalSales: Number(res?.summary?.totalSales) || 0,
  totalInvoices:
    Number(res?.summary?.totalInvoices) || Number(res?.pagination?.total) || 0,
})

export const reportTabFromPath = (pathname) =>
  pathname.includes('/reports/inventory-stock') ? 1 : 0
